import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_322: DocMigration = {
  maxSchemaVersion: "0.0.322",
  description: "Existing columns marked as version V1 now that we have V2",
  apply(json: any): any {
    const { columns } = json;
    for (const columnId in columns) {
      const column = columns[columnId];
      if (column.version === undefined) {
        column.version = "V1";
      }
    }

    return json;
  },
};

export default migration_0_0_322;
